<template>
  <el-container class="pagination-list data-management-detail">
    <el-main>
      <div class="panel">
        <h3>数据详情</h3>
      </div>
      <div class="main">
        <p class="title">字段</p>
        <div class="line"></div>
        <el-form
          class="field"
          label-position="right"
          ref="management"
          :model="management"
          :rules="rules"
          label-width="80px">
          <el-row :gutter="20">
            <el-col :span="6" :offset="4">
              <el-form-item label="数据名" prop="name">
                <el-input v-model="management.name" :disabled="unableEditTable"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="4">
              <el-form-item label="数据类型" prop="dataType">
                <el-select v-model="management.dataType" disabled>
                  <el-option label="系统表" value="DataTable"></el-option>
                  <el-option label="流程表" value="FlowTable"></el-option>
                  <el-option label="报表" value="ReportTable"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="4">
              <el-form-item label="实际表名" prop="tableName">
                <el-input v-model="management.tableName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="4">
              <el-form-item label="表别名" prop="tableName">
                <el-input v-model="management.dbAlias" :disabled="unableEditTable"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <p class="title">表字段列表</p>
        <div class="line"></div>
        <el-button type="primary" @click="addField" class="add-button">添加</el-button>
        <el-table
          :data="items"
          height="300px"
          border>
          <el-table-column
            v-for="(col,index) in cols"
            :key="index"
            :label="col.label"
            align="center"
            :prop="col.prop">
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="100px">
            <template slot-scope="scope">
              <el-button type="text" @click="editdbAlias(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <p class="title">关联表</p>
        <div class="line"></div>
        <el-button type="primary" @click="addRelevanceTable" class="add-button">添加</el-button>
        <el-table :data="associationTable" height="300px" border>
          <el-table-column
            v-for="(col,index) in referencesTableCols"
            :key="index"
            :label="col.label"
            align="center"
            :prop="col.prop">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editRelevanceTable(scope)">编辑</el-button>
              <el-button type="text" @click="delRelevanceTable(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="detail-footer">
        <el-button type="primary" @click="saveManagement('management')">保存</el-button>
        <el-button @click="goBack">取 消</el-button>
      </div>
    </el-main>
    <el-dialog class="pop-up" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" @close="closeDialog">
      <template v-if="dialog.view === 'field'">
        <el-form :model="fieldData" label-width="100px" ref="fieldData" :rules="fieldRules">
          <el-form-item label="字段名" prop="fieldName">
            <el-input :disabled="dialog.title === '编辑别名'" v-model="fieldData.fieldName"></el-input>
          </el-form-item>
          <el-form-item label="数据类型" prop="dataType">
            <el-select :disabled="dialog.title === '编辑别名'" v-model="fieldData.dataType">
              <el-option v-for="(data,index) in dataTypeList" :key="index" :label="data" :value="data"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="实际字段名" prop="virtualName">
            <el-input :disabled="dialog.title === '编辑别名'" v-model="fieldData.virtualName"></el-input>
          </el-form-item>
          <el-form-item label="实际数据类型" prop="virtualDataType">
            <el-select :disabled="dialog.title === '编辑别名'" v-model="fieldData.virtualDataType">
              <el-option v-for="(data,index) in virtualDataTypeList" :key="index" :label="data" :value="data"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="dialog.title === '编辑别名'" label="字段别名" prop="dbAlias">
            <el-input v-model="fieldData.dbAlias" :disabled="unableEditTable || fieldData.protected"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialog.visible = false">取 消</el-button>
          <el-button type="primary" @click="addTableList('fieldData')">确 定</el-button>
        </div>
      </template>
      <template v-if="dialog.view === 'delField'">
        <div><i class="el-icon-warning"></i>此操作将永久删除该数据, 是否继续?</div>
        <div slot="footer">
          <el-button @click="dialog.visible = false">取 消</el-button>
          <el-button type="primary" @click="deleteField">确 定</el-button>
        </div>
      </template>
      <template v-if="dialog.view === 'relevanceTable'">
        <el-form :inline="true" :model="association" :rules="associationRules" ref="association">
          <el-form-item label="主表字段" prop="mainField">
            <el-select v-model="association.mainField">
              <el-option v-for="(data,index) in items" :key="index" :label="data.name" :value="data.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联表名" prop="tableName">
            <el-select v-model="association.tableName" @change="getField">
              <el-option v-for="(data,index) in associatedName" :key="index" :label="data.name" :value="data.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联表字段" prop="relevanceField">
            <el-select v-model="association.relevanceField">
              <el-option v-for="(data,index) in associatedField" :key="index" :label="data.name" :value="data.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialog.visible = false">取 消</el-button>
          <el-button type="primary" @click="saveRelevance('association')">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </el-container>
</template>

<script>
import { UUID } from '@/plugins/common'
import CookieOperation from '@/plugins/cookie'
export default {
  name: 'dataManagementDetail',
  data () {
    return {
      addFields: false,
      index: '',
      primaryTable: '',
      associatedName: [],
      associatedField: [],
      dialog: {},
      fieldId: '',
      association: {
        mainField: '',
        tableName: '',
        relevanceField: ''
      },
      fieldData: {
        virtualDataType: '',
        fieldName: '',
        virtualName: '',
        dataType: '',
        id: '',
        dbAlias: '',
        protected: false
      },
      dataTypeList: ['BIT', 'INT', 'LONG', 'DECIMAL', 'IDENTITY', 'VARCHAR', 'TEXT', 'DATETIME', 'DATE', 'TIME',
        'ENUM', 'HTML', 'FILE', 'NONE'],
      virtualDataTypeList: ['bit', 'int', 'bigint', 'decimal(18, 6)', 'char(36)', 'varchar(500)', 'text', 'datetime',
        'date', 'time', 'enum', 'html', 'varchar(500)', 'none'],
      rules: {
        name: [
          {required: true, message: '请输入数据名', trigger: 'blur'},
          {pattern: /\S/, required: true, message: '请输入数据名', trigger: 'blur'}
        ],
        dataType: [
          {required: false, message: '请选择数据类型', trigger: 'change'}
        ],
        tableName: [
          {required: true, message: '请输入实际表名', trigger: 'blur'},
          {pattern: /\S/, required: true, message: '请输入实际表名', trigger: 'blur'}
        ]
      },
      fieldRules: {
        fieldName: [
          {required: true, message: '请输入字段名', trigger: 'blur'},
          {pattern: /\S/, required: true, message: '请输入字段名', trigger: 'blur'}
        ],
        dataType: [
          {required: true, message: '请选择数据类型', trigger: 'change'}
        ],
        virtualName: [
          {required: true, message: '请输入实际字段名', trigger: 'blur'},
          {pattern: /\S/, required: true, message: '请输入实际字段名', trigger: 'blur'}
        ]
      },
      associationRules: {
        mainField: [
          {required: true, message: '请选择主表字段', trigger: 'change'}
        ],
        tableName: [
          {required: true, message: '请选择关联表名', trigger: 'change'}
        ],
        relevanceField: [
          {required: true, message: '请选择关联表字段', trigger: 'change'}
        ]
      },
      // 表字段列表
      items: [],
      // 主表字段列表
      associationTable: [],
      // 字段
      management: {name: '', dataType: 'DataTable', tableName: '', dbAlias: '', protected: true},
      referencesTable: {primaryKeyName: '', foreignTableName: '', foreignKeyName: ''},
      referencesTableCols: [
        {prop: 'primaryKeyName', label: '主表字段'},
        {prop: 'foreignTableName', label: '关联表名'},
        {prop: 'foreignKeyName', label: '关联表字段'}],
      cols: [
        {prop: 'name', label: '字段名'},
        {prop: 'columnType', label: '数据类型'},
        {prop: 'columnName', label: '实际字段名 '},
        {prop: 'practicalType', label: '实际数据类型'},
        {prop: 'dbAlias', label: '别名'}
      ],
      // 黑名单
      blackInfo: ''
    }
  },
  async mounted () {
    // 先获取黑名单
    await this.getBlackInfo()
    this.getTableData()
  },
  computed: {
    unableEditTable () {
      // 表被保护 || 黑名单时禁止编辑
      return Boolean(this.management.protected || (this.blackInfo && this.blackInfo.includes(CookieOperation.get('tenantId'))))
    }
  },
  methods: {
    getBlackInfo () {
      return this.$axios.get('/data-api/table/blackInfo').then(res => {
        this.blackInfo = res.data
      })
    },
    getTableData () {
      if (this.$route.params.id !== undefined) {
        this.$axios.get(`/data-api/table/tableInfo/${this.$route.params.id}`).then(res => {
          let editData = res.data
          this.management.name = editData.name
          this.management.tableName = editData.tableName
          this.management.dbAlias = editData.dbAlias
          this.management.protected = editData.protected
          this.primaryTable = editData.id
          this.items = editData.columns
          this.associationTable = editData.reference || []
        })
      } else {
        this.primaryTable = UUID.create()
      }
    },
    delData () {
      this.openDialog('delField', '删除字段', '480px')
    },
    delAssociatedData () {
      this.openDialog('delField', '删除关联表字段', '480px')
    },
    addField () {
      this.fieldData.fieldName = ''
      this.fieldData.virtualDataType = ''
      this.fieldData.virtualName = ''
      this.fieldData.dataType = ''
      this.fieldData.id = ''
      this.fieldData.dbAlias = ''
      this.openDialog('field', '添加字段', '680px')
    },
    addRelevanceTable () {
      this.associatedField = []
      this.associatedName = []
      this.association.tableName = ''
      this.association.relevanceField = ''
      this.association.mainField = ''
      this.$axios.get(`/data-api/table`).then(res => {
        this.associatedName = res.data
        this.associatedName.splice(this.associatedName.findIndex(e => e.id === this.primaryTable), 1)
      })
      this.openDialog('relevanceTable', '添加关联表', '940px')
    },
    editRelevanceTable (row) {
      this.index = row.$index
      let editFieldList = this.associationTable[this.index]
      let editId = editFieldList.foreignTable
      let edit = true
      this.getField(editId, edit)
      this.association.mainField = editFieldList.primaryKey
      this.association.tableName = editFieldList.foreignTable
      this.association.relevanceField = editFieldList.foreignKey
      this.$axios.get(`/data-api/table`).then(res => {
        this.associatedName = res.data
        this.associatedName.splice(this.associatedName.findIndex(e => e.id === this.primaryTable), 1)
      })
      this.openDialog('relevanceTable', '编辑关联表', '940px')
    },
    addTableList (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.dialog.title === '添加字段') {
            let uuid = UUID.create()
            this.fieldData.id = uuid
            this.items.push({
              name: this.fieldData.fieldName,
              columnName: this.fieldData.virtualName,
              columnType: this.fieldData.dataType,
              id: this.fieldData.id,
              practicalType: this.fieldData.virtualDataType
            })
          } else if (this.dialog.title !== '编辑别名') {
            this.items[this.index].name = this.fieldData.fieldName
            this.items[this.index].columnName = this.fieldData.virtualName
            this.items[this.index].columnType = this.fieldData.dataType
          } else if (this.dialog.title === '编辑别名') {
            let i = this.items.findIndex(e => e.id === this.fieldData.id)
            this.$set(this.items[i], 'dbAlias', this.fieldData.dbAlias)
          }
          this.dialog.visible = false
        } else {
          return false
        }
      })
    },
    saveRelevance (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let primaryKeyNameIndex = this.associationTable.findIndex(e => e.primaryKey === this.association.mainField && e.foreignTable === this.association.tableName && e.foreignKey === this.association.relevanceField)
          if (primaryKeyNameIndex !== -1) {
            this.$message.warning('请勿做重复关联')
            return false
          }
          if (this.dialog.title === '添加关联表') {
            this.associationTable.push({
              primaryKeyName: this.items[this.items.findIndex(e => e.id === this.association.mainField)].name,
              foreignTableName: this.associatedName[this.associatedName.findIndex(e => e.id === this.association.tableName)].name,
              foreignKeyName: this.associatedField[this.associatedField.findIndex(e => e.id === this.association.relevanceField)].name,
              id: UUID.create(),
              primaryTable: this.primaryTable,
              primaryKey: this.association.mainField,
              foreignTable: this.association.tableName,
              foreignKey: this.association.relevanceField,
              relationType: `${this.management.name}-${this.associatedName[this.associatedName.findIndex(e => e.id === this.association.tableName)].name}`
            })
          } else {
            this.associationTable[this.index].primaryKey = this.association.mainField
            this.associationTable[this.index].foreignTable = this.association.tableName
            this.associationTable[this.index].foreignKey = this.association.relevanceField
            this.associationTable[this.index].primaryKeyName = this.items[this.items.findIndex(e => e.id === this.association.mainField)].name
            this.associationTable[this.index].foreignTableName = this.associatedName[this.associatedName.findIndex(e => e.id === this.association.tableName)].name
            this.associationTable[this.index].foreignKeyName = this.associatedField[this.associatedField.findIndex(e => e.id === this.association.relevanceField)].name
          }
          this.index = ''
          this.dialog.visible = false
        } else {
          return false
        }
      })
    },
    // 清空表单校验
    closeDialog () {
      if (this.dialog.view === 'field') {
        this.$refs.fieldData.resetFields()
      } else if (this.dialog.view === 'relevanceTable') {
        this.$refs.association.resetFields()
      }
    },
    deleteField () {
      if (this.dialog.title === '删除字段') {
        this.items.splice(this.index, 1)
        this.index = ''
      } else {
        this.associationTable.splice(this.index, 1)
        this.index = ''
      }
      this.dialog.visible = false
    },
    delRelevanceTable (row) {
      this.index = row.$index
      this.delAssociatedData()
    },
    // 获取关联表字段
    getField (data, edit) {
      this.$axios.get(`/data-api/table/tableInfo/${data}`).then(res => {
        this.associatedField = res.data.columns
        if (!edit) {
          this.association.relevanceField = this.associatedField[0].id
        }
      })
    },
    // 打开对应弹窗
    openDialog (view, title, width) {
      this.dialog = {
        visible: true,
        view,
        title,
        width
      }
    },
    saveManagement (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.params.id !== undefined) {
            let params = this.management
            this.associationTable.primaryTable = this.primaryTable
            params.id = this.primaryTable
            params.columns = this.items
            params.reference = this.associationTable
            this.$axios.post(`/data-api/table/updateTable`, params).then(res => {
              if (res.status === 200) {
                this.$message.success('保存成功!')
                this.$router.go(-1)
              }
            })
          } else {
            let params = this.management
            this.associationTable.primaryTable = this.primaryTable
            params.id = this.primaryTable
            params.columns = this.items
            params.reference = this.associationTable
            this.$axios.post(`/data-api/table/createTable`, params).then(res => {
              if (res.status === 200) {
                this.$message.success('保存成功!')
                this.$router.go(-1)
              } else {
                this.$message.error(res.data.message)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    // 编辑别名
    editdbAlias (row) {
      this.fieldData.fieldName = row.name
      this.fieldData.virtualDataType = row.practicalType
      this.fieldData.virtualName = row.columnName
      this.fieldData.dataType = row.columnType
      this.fieldData.id = row.id
      this.fieldData.dbAlias = row.dbAlias
      this.fieldData.protected = row.protected
      this.openDialog('field', '编辑别名', '680px')
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  .data-management-detail {
    .pop-up{
      .el-dialog__body{
        border-bottom: 1px dotted #cccccc;
      }
      .el-form-item--mini.el-form-item{
        display: inline-block;
        margin-left: 10px;
      }
      .el-icon-warning{
        font-size: 40px;
        color: rgb(255, 142, 39);
        vertical-align: middle;
        margin-right: 20px;
      }
    }
    .main {
      padding: 10px;
      height: calc(100% - 100px);
      overflow: auto;
      .el-table__row td {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .cell {
          white-space: nowrap;
        }
      }
      .title {
        color: #666;
        margin-bottom: 10px;
      }
      .line {
        width: 100%;
        height: 1px;
        background: #f3f6f8;
      }
      .add-button {
        margin: 10px 0;
      }

      .field {
        width: 100%;
        .el-select {
          display: block;
        }
        .el-input {
          .el-input__inner {
            height: 35px;
            line-height: 35px;
            padding: 6px 12px;
            width: 100%;
          }
        }
      }
    }
    .field-form {
      .el-input {
        width: 193px;
      }
    }
    .detail-footer {
      padding-top: 30px;
      display: flex;
      justify-content: center;
      text-align: center;
      align-items: center;
      border-top: 1px dashed #c2c3c4;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/data/data-management-detail.vue